import { Component } from '@angular/core';

@Component({
    selector: 'app-circle-info',
    templateUrl: './circle-info.component.html',
    styleUrls: ['./circle-info.component.scss'],
})
export class CircleInfoComponent {}
